/*
 * Cada fotografía real se registra aquí para mantener el collage fácil de
 * actualizar. Los formatos disponibles son: featured, portrait, landscape
 * y compact. `objectPosition` es opcional y sólo ajusta el encuadre visual.
 */
export const galleryItems = [
  {
    id: 'francesa-blanca',
    src: './assets/gallery/francesa-blanca.jpg',
    alt: 'Manicura francesa blanca sobre base natural con brillo sutil',
    caption: 'Francesa blanca · acabado natural',
    layout: 'featured',
    objectPosition: 'center',
  },
  {
    id: 'animal-print-floral',
    src: './assets/gallery/animal-print-floral.jpg',
    alt: 'Uñas largas con diseños florales y animal print en blanco y negro',
    caption: 'Diseño floral y animal print',
    layout: 'portrait',
    objectPosition: 'center 42%',
  },
  {
    id: 'burdeo-flor-blanca',
    src: './assets/gallery/burdeo-flor-blanca.jpg',
    alt: 'Manicura color burdeo brillante con una flor blanca en relieve',
    caption: 'Burdeo profundo · detalle floral',
    layout: 'compact',
  },
  {
    id: 'floral-multicolor',
    src: './assets/gallery/floral-multicolor.jpg',
    alt: 'Uñas almendradas con flores de distintos colores sobre mezclilla',
    caption: 'Composición floral multicolor',
    layout: 'portrait',
  },
  {
    id: 'celeste-animal-print',
    src: './assets/gallery/celeste-animal-print.jpg',
    alt: 'Manicura celeste con uñas blancas y detalles de animal print negro',
    caption: 'Celeste suave · animal print',
    layout: 'landscape',
  },
  {
    id: 'ombre-blanco-floral',
    src: './assets/gallery/ombre-blanco-floral.jpg',
    alt: 'Uñas con degradado blanco y delicados trazos florales',
    caption: 'Ombré blanco · trazos florales',
    layout: 'portrait',
  },
  {
    id: 'francesa-rosada-glitter',
    src: './assets/gallery/francesa-rosada-glitter.jpg',
    alt: 'Uñas largas con francesa blanca, base rosada y acabado brillante',
    caption: 'Francesa rosada · brillo delicado',
    layout: 'compact',
  },
  {
    id: 'francesa-negra-animal-print',
    src: './assets/gallery/francesa-negra-animal-print.jpg',
    alt: 'Manicura francesa negra con borde dorado y puntas animal print',
    caption: 'Francesa negra · acentos dorados',
    layout: 'featured',
  },
  {
    id: 'gris-animal-print-dorado',
    src: './assets/gallery/gris-animal-print-dorado.jpg',
    alt: 'Manicura gris con animal print y delicados detalles dorados',
    caption: 'Gris editorial · detalles dorados',
    layout: 'landscape',
  },
  {
    id: 'francesa-blanca-lineas-doradas',
    src: './assets/gallery/francesa-blanca-lineas-doradas.jpg',
    alt: 'Uñas blancas con líneas onduladas doradas sobre base natural',
    caption: 'Blanco y dorado · líneas orgánicas',
    layout: 'portrait',
  },
  {
    id: 'francesa-blanca-destellos',
    src: './assets/gallery/francesa-blanca-destellos.jpg',
    alt: 'Francesa blanca cuadrada con pequeños destellos de colores',
    caption: 'Francesa blanca · destellos',
    layout: 'compact',
  },
  {
    id: 'turquesa-azul-texturas',
    src: './assets/gallery/turquesa-azul-texturas.jpg',
    alt: 'Uñas largas turquesa y azul con texturas y detalles dorados',
    caption: 'Turquesa y azul · juego de texturas',
    layout: 'featured',
  },
  {
    id: 'esmaltado-fucsia',
    src: './assets/gallery/esmaltado-fucsia.jpg',
    alt: 'Uñas ovaladas con esmaltado fucsia brillante',
    caption: 'Fucsia intenso · acabado brillante',
    layout: 'compact',
  },
  {
    id: 'rosa-rana-flores',
    src: './assets/gallery/rosa-rana-flores.jpg',
    alt: 'Manicura rosada con flores, destellos y una pequeña rana verde',
    caption: 'Rosa creativo · flores y rana',
    layout: 'portrait',
  },
  {
    id: 'burdeo-marmol',
    src: './assets/gallery/burdeo-marmol.jpg',
    alt: 'Uñas cuadradas burdeo con efecto mármol rosado y líneas doradas',
    caption: 'Burdeo · efecto mármol',
    layout: 'landscape',
  },
  {
    id: 'tonos-tierra-hojas',
    src: './assets/gallery/tonos-tierra-hojas.jpg',
    alt: 'Manicura en tonos tierra y beige con hojas pintadas a mano',
    caption: 'Tonos tierra · diseño botánico',
    layout: 'portrait',
  },
  {
    id: 'rosa-mariposa',
    src: './assets/gallery/rosa-mariposa.jpg',
    alt: 'Uñas rosadas con mariposa blanca, estrellas y detalles brillantes',
    caption: 'Rosa luminoso · mariposa',
    layout: 'featured',
  },
  {
    id: 'francesa-roja',
    src: './assets/gallery/francesa-roja.jpg',
    alt: 'Uñas almendradas con francesa roja sobre base natural',
    caption: 'Francesa roja · forma almendrada',
    layout: 'landscape',
  },
];
